import { Allergy } from './../Models/allergy.models';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AllergyService {


  url = environment.Url+'Allergies';

  header = new HttpHeaders({

    'Authorization': 'token' + localStorage.getItem('token')

  })

  constructor(private http: HttpClient) { }




  registerAllergy(body){
    return this.http.post<Allergy>(this.url,body).pipe(
     catchError(this.handleError)
   );
     }

   getAllergys(){
    return this.http.get<Allergy[]>(this.url).pipe(catchError(this.handleError)
    
    );
   }
   getAllergyById(id){
    return this.http.get<Allergy>(this.url+'/'+id)
  }

  updateAllergy(id,body){
   return this.http.put<Allergy>(this.url+'/'+id,body).pipe(catchError(this.handleError));
  }

  deleteAllergy(id){
return this.http.delete<Allergy>(this.url+'/'+id).pipe(catchError(this.handleError));
  }



  
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error)
        return throwError(
          error.error
        )


      }
     else if(error.status ==401){
       return throwError('invalid username or password')

     }
      else if (error.status == 0) {
        return throwError(
          'network failure please try again later '
        )
      }
      return throwError(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };


}



